import * as React from "react";
import { Group as MantineGroup } from "@mantine/core";
const Group = ({ ...props }) => /* @__PURE__ */ React.createElement(MantineGroup, { ...props });
export default Group;
